import { DeepPartial, AppConfig } from "../../../../src/app/interfaces/app-config";

export const projectConfig: DeepPartial<AppConfig> = {
    // Ejemplo
     pages: {
         login: {
            title: 'Iniciar sesión',
            subtitle: 'Introduzca su correo electrónico y contraseña para iniciar sesión',
            form: {
                email: {
                    label: 'Usuario',
                    placeholder: 'Ingresa tu código de usuario...'
                },
                password: {
                    label: 'Contraseña',
                    placeholder: 'Ingresa tu contraseña'
                },
                rememberMe: {
                    label: 'Recordarme'
                },
            },
            socialAuth: 'O inicia sesión con',
            forgotPassword: '¿Ha olvidado su contraseña?',
            submit: 'Iniciar sesión',
            nextAuth: {
                question: '¿No tienes cuenta?',
                action: 'Registrate aquí'
            }
        },
         register: {
          title: 'Registrate',
          subtitle: 'Introduzca sus datos personales para crear una cuenta',
          form: {
              name: {
                  label: 'Número de documento (Usuario)',
                  placeholder: 'Ingresa tu CI o NIT'
              },
              email: {
                  label: 'Correo electrónico',
                  placeholder: 'Ingresa tu correo electrónico'
              },
              cellphone: {
                  label: 'Número celular',
                  placeholder: 'Ingresa tu número celular'
              },
              password: {
                  label: 'ID de cuenta (Contraseña)',
                  placeholder: 'Ingresa tu contraseña'
              },
              terms: {
                  label: 'Acepto los ',
                  action: 'términos y condiciones'
              },
              licenceNumber: {
                  label: 'Número de licencia ',
                  placeholder: 'Ingresa tu número de licencia'
              }
          },
          socialAuth: 'O registrate con',
          submit: 'Registrarse',
          nextAuth: {
              question: '¿Ya tienes una cuenta?',
              action: 'Inicia sesión'
          }
        },
        profile: {
            titlePlural: 'Registros',
            titleSingular: 'Registro',
            form_filter: {
                name:{
                    label: 'Nombre',
                    placeholder: 'Escribir nombre'
                },
                lastName:{
                    label: 'Apellido',
                    placeholder: 'Escribir apellido'
                },
                email:{
                    label: 'Correo electrónico',
                    placeholder: 'Escribir correo electrónico'
                },
                numberCi:{
                    label: 'Numero de carnet',
                    placeholder: 'Escribir numero carnet'
                },
                initial_date:{
                    label: 'Fecha inicio',
                    placeholder: 'Escribir...'
                },
                end_date:{
                    label: 'Fecha fin',
                    placeholder: 'Escribir...'
                },
                city:{
                    label: 'Ciudad',
                    placeholder: 'Escribir...'
                },
                event:{
                    label: 'Eventos',
                    placeholder: 'Seleccionar...'
                },
            }
        },
        historyTickets: {
            titlePlural: 'Tickets',
            titleSingular: 'Ticket',
            form:{},
            form_filter: {
                search: {
                    label: 'Buscar código',
                    placeholder: 'Escribir...'
                },
                name:{
                    label: 'Nombre',
                    placeholder: 'Escribir...'
                },
                lastName:{
                    label: 'Apellido',
                    placeholder: 'Escribir...'
                },
                email:{
                    label: 'Correo electrónico',
                    placeholder: 'Escribir...'
                },
                numberCi:{
                    label: 'Numero de carnet',
                    placeholder: 'Escribir...'
                },
                initial_date:{
                    label: 'Fecha inicio',
                    placeholder: 'Escribir...'
                },
                end_date:{
                    label: 'Fecha fin',
                    placeholder: 'Escribir...'
                },
                event:{
                    label: 'Eventos',
                    placeholder: 'Seleccionar...'
                },
            }
        },
        vehicles: {
            titlePlural: 'Vehículos',
            titleSingular: 'Vehículo',
            form:{},
        },
        deposit: {
            titlePlural: 'Mis Recargas',
            titleSingular: 'Mi Recarga',
            form:{},
        },
        transactions: {
            titlePlural: 'Mis Peajes Pagados',
            titleSingular: 'Mi Peaje Pagado',
            form:{},
        },
        recharge: {
            titlePlural: 'Realizar Recargas',
            titleSingular: 'Realizar Recarga',
            form:{
                amount: {
                    label: 'Monto',
                    placeholder: '00.00'
                },
                nit: {
                    label: 'NIT',
                    placeholder: 'Ingresar nit...'
                },
                companyName: {
                    label: 'Razón Social',
                    placeholder: 'Ingresa razón social...'
                }
            },
        },
     },

    menu: [
        {
            headTitle1: "General",
            permissions: 'default',
        },
        {
            id: 1,
            level: 1,
            path: '/home',
            title: "Inicio",
            icon: "home",
            type: "link",
            permissions: 'default',
        },
        {
          id: 2,
          level: 1,
          path: 'recharge',
          title: "Realizar recarga",
          icon: "bookmark",
          type: "link",
          permissions:'default',
        },
        {
          id: 3,
          level: 1,
          path: 'change-vehicle',
          title: "Cambiar vehículo",
          icon: "bookmark",
          type: "link",
          permissions:'default',
        },
        {
          id: 4,
          level: 1,
          path: 'change-phone',
          title: "Cambiar teléfono",
          icon: "bookmark",
          type: "link",
          permissions:'default',
        },
        {
          id: 5,
          level: 1,
          path: 'payments-history',
          title: "Historial de recargas",
          icon: "bookmark",
          type: "link",
          permissions:'default',
        },
        {
          id: 5,
          level: 1,
          path: 'trips-history',
          title: "Historial de viajes",
          icon: "bookmark",
          type: "link",
          permissions:'default',
        },
    ],
    adminMenu: [
        {
          "headTitle1": "General",
          "permissions": "default"
        },
        {
           id: 1,
           level: 1,
           path: '/admin/dashboard',
           title: "Dashboard",
           icon: "home",
           type: "link",
        },
        {
           id: 2,
           level: 1,
           path: '/admin/users',
           title: "Usuarios",
           icon: "bookmark",
           type: "link",
        },
        {
           id: 3,
           level: 1,
           path: '/admin/roles-permissions',
           title: "Roles y permisos",
           icon: "bookmark",
           type: "link",
        },
        {
           id: 4,
           level: 1,
           path: '/admin/drivers',
           title: "Conductores",
           icon: "bookmark",
           type: "link",
        },
        {
           id: 5,
           level: 1,
           path: '/admin/reload',
           title: "Recargas",
           icon: "bookmark",
           type: "link",
        },
        {
           id: 6,
           level: 1,
           path: '/admin/trips',
           title: "Viajes",
           icon: "bookmark",
           type: "link",
        },
    ],
};
